<template>
  <v-card :loading="!fetched || savingInProgress" class="">
    <v-card-title class="pa-2">
    <h4 class="px-2">
      {{ $t("viewOrdersForm.responsible_for_order") }} #{{ order.human_number }}
      <v-btn
        color="success"
        class="ml-1 green-shadow"
        x-small
        fab
        max-width="26"
        max-height="26"
        @click.stop="add = !add"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>

    </h4><v-spacer></v-spacer>
    <v-btn icon @click="cancel">
      <v-icon>fa-times</v-icon>
    </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-layout class="pa-3 pt-2">
      <v-form ref="responsible" class="w-100">
        <v-row v-show="add">
          <v-col cols="4">
            <v-select
              return-object
              dense
              outlined
              v-if="orderStages.length > 0"
              :items="orderStages"
              :label="$t('common.order_stage')"
              item-text="name"
              item-value="id"
              v-model="newResponsibleFor.stage"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
            ></v-select>
          </v-col>
          <v-col cols="5">
            <v-select
              return-object
              dense
              outlined
              v-if="users.length > 0"
              :items="users"
              :label="$t('viewOrdersForm.person_responsible_for')"
              item-text="name"
              item-value="id"
              v-model="newResponsibleFor.responsible_user"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
            ></v-select>
          </v-col>
          <v-col cols="3" class="text-right">
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              @click="
                newResponsibleFor = {};
                add = !add;
              "
              @keyup.enter.stop="
                newResponsibleFor = {};
                add = !add;
              "
              color="red lighten-2"
              class="mb-0 px-0 white--text"
              :title="$t('common.cancel')"
            >
              <v-icon small>$cross</v-icon>
            </v-btn>
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              @click="addResponsibleFor"
              @keyup.enter.stop=""
              color="success"
              class="mb-0 ml-3 px-0 white--text"
              :title="$t('common.add')"
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          v-if="order.responsible_for && order.responsible_for.length"
          :headers="[
            {
              text: this.$t('common.order_stage'),
              value: 'name',
              sortable: true,
            },
            {
              text: this.$t('viewOrdersForm.person_responsible_for'),
              value: 'email',
              sortable: true,
            },
            { text: '', value: 'email', sortable: false },
          ]"
          :items="order.responsible_for"
          class="elevation-0 mb-3 mx-3"
          :footer-props="{
            'items-per-page-text': $t('tables.items_per_page'),
            'items-per-page-options': [
              10, 50, 100,
              //-1
            ],
          }"
        >
          <template v-slot:footer.page-text="props">
            {{
              $t("tables.x_of_y", [
                `${props.pageStart}-${props.pageStop}`,
                props.itemsLength,
              ])
            }}
          </template>
          <template v-slot:item="props">
            <tr>
              <td class="text-xs-left">
                {{ (props.item.stage && props.item.stage.name) || "Deleted" }}
              </td>
              <td class="text-xs-left">
                {{ props.item.responsible_user.name }}
              </td>
              <td class="text-xs-left">
                <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  @click="
                    order.responsible_for = order.responsible_for.filter(
                      (item) => item !== props.item
                    )
                  "
                  color="red lighten-2"
                  class="mb-0 ml-3 px-0 white--text"
                  :title="$t('common.remove')"
                >
                  <v-icon small>$trash</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            {{ $t("common.no_data_available") }}
          </template>
          <template v-slot:no-results>
            {{ $t("common.no_data_available") }}
          </template>
        </v-data-table>
        <template v-else>
          {{ order.created_by_user ? order.created_by_user.name : "" }}
        </template>
        <v-divider class="my-5"></v-divider>
        <div class="text-right">
          <v-btn
            class="mt-0 white--text mr-3"
            color="red"
            elevation="0"
            @click="cancel"
            @keyup.enter="cancel"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            class="mt-0 white--text"
            color="primary"
            elevation="0"
            @click="submit"
            @keyup.enter="submit"
          >
            {{ $t("common.save") }}
          </v-btn>
        </div>
      </v-form>
    </v-layout>
  </v-card>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "AddResponsibleForOrder",
  props: {
    order: null,
  },
  data: () => ({
    add: false,
    newResponsibleFor: {},
  }),
  computed: {
    ...mapFields("order_stages", [
      "orderStages",
      "fetched",
      "savingInProgress",
    ]),
    ...mapFields("users", ["users"]),
  },
  mounted() {
    this.onLoad();
  },
  watch:{
    add(to){
      if(to){
        this.$refs["responsible"].resetValidation()
      }
    }
  },
  methods: {
    submit() {
      this.$store.dispatch("orders/ordersUpdate", this.order).then((res) => {
        if (res) this.$emit("store", res);
      });
    },
    onLoad() {
      this.$store.dispatch("order_stages/get");
      this.$store.dispatch("users/get");
    },
    cancel() {
      this.$emit("cancel");
    },
    addResponsibleFor() {
      if (this.$refs["responsible"].validate()) {
        this.order.responsible_for.push(Object.assign(this.newResponsibleFor));
        this.newResponsibleFor = {};
        this.add = false;
      }
    },
  },
};
</script>

<style scoped></style>
